export default "__VITE_ASSET__2f589a83__"